import React, { useState } from "react";
import AuthContext from "./AuthContext";

const AuthProvider = props => {
    const [state, setState] = useState({
        loginMode: false
    });
    return (
        <AuthContext.Provider
            value={{
                data: state,
                updateLoginMode: () => {

                    if(!state.loginMode) {
                        setState({ ...state, loginMode: true});
                    } else {
                        setState({ ...state, loginMode: false});
                    }
                }
            }}
        >
            {props.children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;